export function jobPublicPath(jobId: string): `/jobs/${string}` {
  return `/jobs/${jobId}`
}

export function jobPublicUrl(
  jobId: string,
  origin = typeof window === "undefined" ? "" : window.location.origin,
): string {
  return `${origin}${jobPublicPath(jobId)}`
}

export function jobShareTitle(title: string, companyName?: string): string {
  const trimmedCompany = companyName?.trim()
  return trimmedCompany ? `${title} at ${trimmedCompany}` : title
}

export type ShareJobResult = "shared" | "copied" | "cancelled"

function isAbort(error: unknown): boolean {
  return error instanceof DOMException && error.name === "AbortError"
}

/**
 * Prefer the OS share sheet; copy the public role URL when it isn't available.
 */
export async function shareJob(opts: {
  jobId: string
  title: string
  companyName?: string
  origin?: string
}): Promise<ShareJobResult> {
  const url = jobPublicUrl(opts.jobId, opts.origin)
  const title = jobShareTitle(opts.title, opts.companyName)
  // Do not set `text`: WhatsApp and other share targets concatenate it onto
  // `url`, producing `/jobs/<id> <title>` which the role page then rejects.
  const payload: ShareData = { title, url }

  if (typeof navigator.share === "function") {
    try {
      const allowed =
        typeof navigator.canShare !== "function" || navigator.canShare(payload)
      if (allowed) {
        await navigator.share(payload)
        return "shared"
      }
    } catch (error) {
      if (isAbort(error)) return "cancelled"
    }
  }

  await navigator.clipboard.writeText(url)
  return "copied"
}
